// @flow
import { getFromConfig } from '~/core/state/config';
import url from 'url';

export function getWeather(postcode: string, country: string): Promise<Response> {
    const endpoint: string = getFromConfig('weatherApi');
    const { host, port, protocol, pathname } = url.parse(endpoint);
    const apiUrl = url.format({
        host,
        protocol,
        port,
        query: { postcode, country },
        pathname
    });

    return fetch(apiUrl);
}



// WEBPACK FOOTER //
// ./src/core/api/weather/index.js